import { useEffect, useState } from "react"
import { getAllHotels } from "../../../../../services/hotelService";

const useGetHotelisActive = (props) => {
    const [isActive, setIsActive] = useState([props.isActive]);
    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await getAllHotels({
                    isactive: props.isActive,
                    isBeachVilla: props.isBeachVilla
                });
                setIsActive(response)
            } catch (error) {
                setIsActive(false)
            }
        }
        fetchStatus();
    }, [props.isBeachVilla, props.isActive])

    return [isActive]
}

export default useGetHotelisActive;